import React from "react"
import Modal from "src/components/modals/Modal"
import getWordByModelName from "src/helpers/text/getWordByModelName"

const FilterModal = ({
  modelName,
  isOpen,
  onOk,
  onCancel,
  width,
  dirty,
  invalid,
  children,
  title,
}) => {
  return (
    <Modal
      title={title || `Фильтр ${getWordByModelName(modelName, true)}`}
      buttonConf={[
        {
          text: `Применить`,
          onClick: onOk,
          isOk: true,
          done: !dirty,
          disabled: !dirty || !!invalid,
        },
        {
          text: `Закрыть`,
          onClick: onCancel,
          disabled: false,
        },
      ]}
      isOpen={isOpen}
      onCancel={onCancel}
      pending={false}
      fullWidth={false}
      fullHeight
      width={width}
      hasOverlay
    >
      {children}
    </Modal>
  )
}

export default FilterModal
